import { Action } from 'redux';

import {
  SiteUserAddToIdentityPool,
  SiteUserAddUsers, SiteUserEditGroupMembership,
  SiteUserEditSiteRole, SiteUserForcePasswordUpdate, SiteUserRemove,
  SiteUserRemoveFromIdentityPool,
  SiteUserResetLoginRateLimiting, SiteUserSetAuthentication
} from '../../../bootstrap/redux/actions/AppActionTypes';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export interface SiteUserAddAction extends Action {}

export function addSiteUsers(): SiteUserAddAction {
  return {
    type: SiteUserAddUsers,
  };
}

export interface SiteUserMenuAction extends Action {
  items: ISiteUserInfo[];
}

export function siteUserRemove(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserRemove,
    items
  };
}

export function siteUserEditSiteRole(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserEditSiteRole,
    items
  };
}

export function siteUserEditGroupMembership(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserEditGroupMembership,
    items
  };
}

export function siteUserEditAuthentication(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserSetAuthentication,
    items
  };
}

export function siteUserForcePasswordUpdate(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserForcePasswordUpdate,
    items
  };
}

export function siteUserResetLoginRateLimiting(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserResetLoginRateLimiting,
    items
  };
}

export function siteUserAddToIdentityPool(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserAddToIdentityPool,
    items
  };
}

export function siteUserRemoveFromIdentityPool(items: ISiteUserInfo[]): SiteUserMenuAction {
  return {
    type: SiteUserRemoveFromIdentityPool,
    items
  };
}
